<template>
  <div class="container-fluid">
    <div class="row marketing">
      <div class="col-lg-3">
        <h4 class="form-head">
          New User
        </h4>
        <form action="" name="cform">
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text" class="form-control"
                   id="name"
                   v-model="f.name"
                   required>
          </div>
          <div class="form-group">
            <label for="exampleInputEmail0">User ID</label>
            <input type="text" class="form-control"
                   id="exampleInputEmail0"
                   v-model="f.userName"
                   required>

          </div>
          <div class="form-group">
            <label for="exampleInputEmail1">Password</label>
            <input type="password" class="form-control"
                   id="exampleInputEmail1"
                   v-model="f.password"
                   required>

          </div>
          <div class="form-group">
            <label for="email">EMail</label>
            <input type="email" class="form-control"
                   id="email"
                   v-model="f.email"
                   required>

          </div>
          <div class="form-group">
            <label for="tel">Mobile</label>
            <input type="tel" class="form-control"
                   id="tel"
                   v-model="f.mobile">

          </div>

          <div class="form-check" v-if="!localAdmin">
            <input type="checkbox" class="form-check-input"
                   id="isAdmin"
                   v-model="f.admin">
            <label for="isAdmin" class="form-check-label">is Admin?</label>

          </div>
          <div class="form-check mt-3 mb-3" v-if="!f.admin && !localAdmin">
            <input type="checkbox" class="form-check-input"
                   id="localAdmin"
                   v-model="f.localAdmin">
            <label for="localAdmin" class="form-check-label">is Local Admin?</label>

          </div>
          <div class="form-group" v-if="!f.admin && ewbTenant">
            <label for="exampleInputEmail4">Permissions</label>
            <select class="form-control"
                    multiple
                    id="exampleInputEmail4"
                    v-model="f.permissions">
              <option value="CREATE_EWB">
                {{description('CREATE_EWB')}}
              </option>
              <option value="UPDATE_EWB">
                {{description('CREATE_EWB')}}
              </option>
              <option value="CANCEL_EWB">
                {{description('CANCEL_EWB')}}
              </option>
              <option value="EXTEND_EWB">
                {{description('EXTEND_EWB')}}
              </option>
              <option value="REJECT_EWB">
                {{description('REJECT_EWB')}}
              </option>
            </select>

          </div>
          <div class="form-group" v-if="!f.admin && podTenant">
            <label for="ut">User Type</label>
            <select class="form-control"
                    id="ut"
                    v-model="f.whomType">
              <option value="REGULAR_USER">
                Company User
              </option>
              <option value="TRANSPORTER">
                Transporter
              </option>
            </select>

          </div>
          <div class="form-group" v-if="!f.admin && ewbTenant">
            <label for="exampleInputEmail5">Allowed States</label>
            <select class="form-control"
                    multiple
                    id="exampleInputEmail5"
                    v-model="f.creds">
              <option v-for="c of creds" :key="c.id" :value="c.id">{{c.state}} &ndash; ({{c.gstNumber}})</option>
            </select>

          </div>

          <div class="form-group" v-if="!f.admin && podTenant">
            <label for="allLocations">Allow ALL Locations?</label>
            <select class="form-control" id="allLocations" v-model="f.allLocations">
              <option :value="true">Yes</option>
              <option :value="false">No</option>
            </select>
          </div>

          <div class="form-group"
               v-if="podTenant && !f.admin && f.whomType !== 'TRANSPORTER' && f.allLocations === false">
            <label for="loca">Allowed Locations</label>
            <select class="form-control" multiple id="loca" v-model="f.locations">
              <option v-for="c of locations" :key="c.id" :value="c.id">{{c.name}}</option>
            </select>
          </div>

          <div class="form-group" v-if="!f.admin && f.whomType === 'TRANSPORTER'">
            <label for="tr">Assign Transporter</label>
            <select class="form-control" id="tr" v-model="f.transporters" multiple="true">
              <option v-for="c of transporters" :key="c.id" :value="c.id">{{c.name}}</option>
            </select>

          </div>

          <button type="button" v-on:click="saveUser()" class="btn btn-primary">
            Save
          </button>

        </form>
      </div>
      <div class="col-lg-9">
        <h4 class="form-head">
          Existing Users
        </h4>
        <table class="table" v-if="ewbTenant">
          <thead class="thead-dark">
          <tr>
            <th>Name</th>
            <th>User ID</th>
            <th>Permissions</th>
            <th>States</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="u of users" :key="u.id">
            <td>{{u.name}}</td>
            <td>{{u.userName}}</td>
            <td v-if="!u.admin">
              <ul class="list-group" style="font-size: small">
                <li class="list-group-item" v-for="l in u.permissions" :key="l">
                  {{description(l)}}
                </li>
              </ul>
            </td>
            <td v-if="!u.admin">
              <ul class="list-group" style="font-size: small">
                <li class="list-group-item" v-for="l in u.creds" :key="l">
                  {{cred(l)}}
                </li>
              </ul>
            </td>
            <td v-if="u.admin" colspan="2" class="">
              Administrator
            </td>
            <td>
              <button class="btn btn-primary btn-sm" v-on:click="editUser(u)">
                <i class="fa fa-pencil"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <div v-if="podTenant">
          <div class="d-flex">
            <div class="d-flex align-content-center align-items-center">
              <div>
                <b-form-input v-model="us"/>
              </div>
              <div>
                <b-button @click="searchUs">Search</b-button>
              </div>
            </div>
            <div class="d-flex flex-fill justify-content-end align-content-center align-items-center">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>

              <p class="mt-3">Current Page: {{ currentPage }}</p>
            </div>
          </div>

          <b-table
            id="my-table"
            :items="fusers"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
            small
          >

            <!-- A custom formatted column -->
            <template #cell(admin)="data">
              <div>
                <span v-if="data.item.admin">Administrator</span>
                <span v-if="data.item.localAdmin">Local Administrator</span>
                <span
                  v-if="!data.item.admin && data.item.whomType === 'REGULAR_USER' && !data.item.admin && !data.item.localAdmin">Company User</span>
                <span v-if="!data.item.admin && data.item.whomType === 'TRANSPORTER'">Transporter</span>
              </div>
            </template>
            <template #cell(locations)="data">
              <div>
                <ul class="list-unstyled"
                    v-if="!data.item.admin && data.item.whomType !== 'TRANSPORTER' && (data.item.allLocations === false || !data.item.allLocations)">
                  <li v-for="l in data.item.locations" :key="l">
                    <span v-if="locationMap[l]"><i class="fa fa-warehouse"></i> {{locationMap[l].name}}</span>
                  </li>
                </ul>
                <span v-if="data.item.admin || data.item.allLocations">All Locations</span>
                <div v-if="data.item.whomType === 'TRANSPORTER'">
                  <span v-if="data.item.whom"><i class="fa fa-truck"></i> {{data.item.whom.name}}</span>
                  <div class="d-flex flex-column" v-if="data.item.transporters">
                    <span v-for="t of data.item.transporters" :key="t"><i class="fa fa-truck"></i> {{transportersMap[t].name}}</span>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(edit)="data">
              <b-button class="btn btn-primary btn-sm" v-on:click="editUser(data.item)" v-b-tooltip.hover
                        title="Edit User">
                <i class="fa fa-pencil"></i>
              </b-button>
            </template>

          </b-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'

let apiUrl = `/app/user`
let credUrl = `/app/cred`
let locationsUrl = `/app/location`
let apiUrlTransporter = `/app/party?type=TRANSPORTER`

export default {
  name: 'UserPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }

      this.loadUsers()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      f: {
        userName: '',
        name: '',
        email: '',
        mobile: '',
        employeeId: '',
        password: '',
        admin: false,
        allLocations: false,
        permissions: ['CREATE_EWB', 'CANCEL_EWB', 'EXTEND_EWB', 'REJECT_EWB', 'UPDATE_EWB'],
        whomType: 'REGULAR_USER',
        whom: null,
        locations: [],
        creds: [],
        id: null
      },
      us: '',
      users: [],
      fusers: [],
      creds: [],
      locations: [],
      transporters: [],
      locationMap: {},
      transportersMap: {},
      perPage: 20,
      currentPage: 1,
      fields: ['name', {
        key: 'userName',
        label: 'User ID'
      }, {
        key: 'admin',
        label: 'User Type'
      }, {
        key: 'locations',
        label: 'Locations/Transporter'
      }, {
        key: 'edit',
        label: ''
      }]
    }
  },
  computed: {
    ewbTenant () {
      return this.$store.state.ewbTenant
    },
    podTenant () {
      return this.$store.state.podTenant
    },
    localAdmin () {
      return this.$store.state.localAdmin
    },
    rows () {
      return this.users.length
    }
  },
  methods: {
    searchUs () {
      if (this.us === '') this.fusers = this.users
      let us = this.us.toLowerCase()
      this.fusers = this.users.filter(u => (u.name && u.name.toLowerCase().indexOf(us) > -1) || (u.userName && u.userName.toLowerCase().indexOf(us) > -1))
      this.currentPage = 1
    },
    saveUser: function () {
      console.log('Saving', this.f)
      let existing = this.users.filter(f => f.userName === this.f.userName).length
      if (this.f.id === null && existing > 0) {
        alert('Cannot Create Duplicate User')
        return
      }
      if (this.f.whomType === 'TRANSPORTER' && (!this.f.whom || !this.f.whom.id)) {
        alert('Select Transporter to save')
        return
      }
      axios.post(apiUrl, this.f)
        .then(response => {
          this.f = {
            userName: '',
            name: '',
            email: '',
            mobile: '',
            employeeId: '',
            password: '',
            admin: false,
            localAdmin: false,
            allLocations: false,
            permissions: [],
            locations: [],
            whomType: 'REGULAR_USER',
            whom: null,
            id: null
          }
          this.loadUsers()
        }, error => {
          console.error('Error in Saving User', error)
        })
    },
    editUser: function (user) {
      console.log('Editing', user)
      this.f = user
    },
    loadUsers: function () {
      axios.all([
        axios.get(apiUrl),
        axios.get(credUrl),
        axios.get(apiUrlTransporter),
        axios.get(locationsUrl)
      ]).then(axios.spread((users, creds, transporters, locations) => {
        this.users = _.sortBy(users.data, ['name', 'userName'])
        this.creds = creds.data
        this.transporters = transporters.data
        this.locations = locations.data
        this.locations.forEach(l => {
          this.locationMap[l.id] = l
        })
        this.transporters.forEach(l => {
          this.transportersMap[l.id] = l
        })

        this.searchUs()
      }))
    },
    description: en => {
      return {
        'CREATE_EWB': 'Generate EWB',
        'UPDATE_EWB': 'Update EWB - PartB',
        'CANCEL_EWB': 'Cancel EWB',
        'EXTEND_EWB': 'Extend EWB',
        'REJECT_EWB': 'Reject EWB'
      }[en] || en
    },
    cred: function (l) {
      let filterElement = this.creds.filter(c => c.id === l)[0]
      return `${filterElement.state} - (${filterElement.gstNumber})`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/UserPage.vue